///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { getDivisionCurrency } from "./laneViewColumns";
import messages from "./messages";
import { cellUnit, controls } from "./types";
import { formatDate } from "./laneCalculations";

export const shipperRatesViewColumns = [
  {
    header: messages.shipperName.defaultMessage,
    field: "shipperName",
    cellUnit: cellUnit.none,
    unitLeft: true,
    left: true,
    control: controls.none,
    filter: true,
    isDraggable: false
  },
  {
    header: messages.code.defaultMessage,
    field: "code",
    cellUnit: cellUnit.none,
    unitLeft: true,
    left: true,
    control: controls.none,
    filter: true,
    isDraggable: false
  },
  {
    header: messages.mode.defaultMessage,
    field: "mode",
    cellUnit: cellUnit.none,
    unitLeft: true,
    left: true,
    control: controls.none,
    filter: true,
    isDraggable: false
  },
  {
    header: messages.rateType.defaultMessage,
    field: "rateType",
    cellUnit: cellUnit.none,
    unitLeft: true,
    left: true,
    control: controls.none,
    filter: true,
    isDraggable: false
  },
  {
    header: messages.flatRate.defaultMessage,
    field: "flatRate",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: messages.perMileRate.defaultMessage,
    field: "perMileRate",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: messages.effective.defaultMessage,
    field: "effective",
    cellUnit: cellUnit.none,
    unitLeft: true,
    right: true,
    control: controls.none,
    filter: true,
    isDraggable: false,
    format: formatDate
  },
  {
    header: messages.expiration.defaultMessage,
    field: "expiration",
    cellUnit: cellUnit.none,
    unitLeft: true,
    right: true,
    control: controls.none,
    filter: true,
    isDraggable: false,
    format: formatDate
  }
];

export const shipperRatesViewColumnsV2 = [
  {
    header: messages.accountName.defaultMessage,
    field: "shipperName",
    cellUnit: cellUnit.none,
    unitLeft: true,
    left: true,
    control: controls.none,
    filter: true,
    isDraggable: false
  },
  {
    header: messages.code.defaultMessage,
    field: "code",
    cellUnit: cellUnit.none,
    unitLeft: true,
    left: true,
    control: controls.none,
    filter: true,
    isDraggable: false
  },
  {
    header: messages.mode.defaultMessage,
    field: "mode",
    cellUnit: cellUnit.none,
    unitLeft: true,
    left: true,
    control: controls.none,
    filter: true,
    isDraggable: false
  },
  {
    header: messages.rateType.defaultMessage,
    field: "rateType",
    cellUnit: cellUnit.none,
    unitLeft: true,
    left: true,
    control: controls.none,
    filter: true,
    isDraggable: false
  },
  {
    header: messages.flatRate.defaultMessage,
    field: "flatRate",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: messages.perMileRate.defaultMessage,
    field: "perMileRate",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: messages.effective.defaultMessage,
    field: "effective",
    cellUnit: cellUnit.none,
    unitLeft: true,
    right: true,
    control: controls.none,
    filter: true,
    isDraggable: false,
    format: formatDate
  },
  {
    header: messages.expiration.defaultMessage,
    field: "expiration",
    cellUnit: cellUnit.none,
    unitLeft: true,
    right: true,
    control: controls.none,
    filter: true,
    isDraggable: false,
    format: formatDate
  }
];

export default shipperRatesViewColumns;